export default "<div class=\"admin\">\n  admin works!\n</div>\n"